// DayJS Context (formerly MomentContext)
import React, { createContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

// Extend dayjs with relativeTime plugin for fromNow() functionality
dayjs.extend(relativeTime);

const MomentContext = createContext();

const MomentProvider = ({ children }) => {
  const [momentInstance, setMomentInstance] = useState(dayjs);
  const data = 'hello';

  useEffect(() => {
    // dayjs is already available as it's imported above
    setMomentInstance(dayjs);
  }, []);

  return <MomentContext.Provider value={{ momentInstance, data }}>{children}</MomentContext.Provider>;
};

export { MomentProvider, MomentContext };
